module.exports = __webpack_public_path__ + "static/media/cars-project.73c08bc4.webp";